import React, { useEffect} from "react";
import { useFormik } from "formik";
import * as Yup from "yup"
export default function AddAdminHotel({onAdd,onEdit,hotelToEdit,setHotelToEdit}){
    const formik=useFormik({
      initialValues:{
      name: "",
      email: "",
      location: "",
      goods_type: "",
      image_url: ""
      },
      validationSchema:Yup.object().shape({
        name: Yup.string().required('Name is required').typeError("Please  enter a string"),
        email: Yup.string().email('Invalid email format').required('Email is required').typeError("Please enter a string"),
        location: Yup.string().required('Location is required').typeError("Please enter a string"),
        goods_type: Yup.string().required('Goods type is required').typeError("Please enter a string"),
        image_url: Yup.string().url('Invalid URL format').required('Image URL is required').typeError("Please enter a url"),
      }),
      onSubmit:async(values,{setSubmitting})=>{
       try {
        if (hotelToEdit){
        await  onEdit(values)
          setHotelToEdit(null)
          formik.resetForm()
        }
        else{
        await  onAdd(values)
          setHotelToEdit(null)
          formik.resetForm()
        }
       } catch (error) {
          console.error("An error occured ocurred adding or deleting hotel",error)
       } 
       finally{
        setSubmitting(false)
       }
        
      }
    })

    useEffect(()=>{
       if (hotelToEdit){
        formik.setValues(hotelToEdit)
       }
    },[hotelToEdit])
  
    return(
      <div className=" max-h-full min-h-fit">
         <form onSubmit={formik.handleSubmit} className=" space-y-2">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Name"
           className="rounded-xl"
        />
        {formik.touched.name && formik.errors.name ? (
          <div className="text-red-500">{formik.errors.name}</div>
        ) : null}

        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Email"
           className="rounded-xl"
        />
        {formik.touched.email && formik.errors.email ? (
          <div className="text-red-500">{formik.errors.email}</div>
        ) : null}

        <label htmlFor="location">Location</label>
        <input
          type="text"
          id="location"
          name="location"
          value={formik.values.location}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Location"
           className="rounded-xl"
        />
        {formik.touched.location && formik.errors.location ? (
          <div className="text-red-500">{formik.errors.location}</div>
        ) : null}

        <label htmlFor="goods_type">Goods Type</label>
        <input
          type="text"
          id="goods_type"
          name="goods_type"
          value={formik.values.goods_type}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Goods Type"
           className="rounded-xl"
        />
        {formik.touched.goods_type && formik.errors.goods_type ? (
          <div className="text-red-500">{formik.errors.goods_type}</div>
        ) : null}

        <label htmlFor="image_url">Image URL</label>
        <input
          type="text"
          id="image_url"
          name="image_url"
          value={formik.values.image_url}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Image URL"
           className="rounded-xl"
        />
        {formik.touched.image_url && formik.errors.image_url ? (
          <div className="text-red-500">{formik.errors.image_url}</div>
        ) : null}
    
        <button type="submit" disabled={formik.isSubmitting || !formik.isValid}  className="bg-blue-500 rounded-lg disabled:opacity-50 ml-4">{hotelToEdit ? "Update Hotel" : "Add Hotel"}</button>
      </form>
      </div>
    )
}